import React, {FunctionComponent, HTMLAttributes} from 'react';

import withStyles from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';

import {Styles, styles} from './MainNavLeft.style';

export interface MainNavLeftProps extends Styles, HTMLAttributes<HTMLDivElement> {}
const MainNavLeft: FunctionComponent<MainNavLeftProps> = ({
  classes,
  className,
  children,
  ...otherProps
}) => (
  <div className={classNames(classes.root, className)} {...otherProps}>
    {children}
  </div>
);

export default withStyles(styles)(MainNavLeft);
